import React from "react";
import { s360ConfigService } from "../Services/S360Config";

export default function MessageNotification(props) {
  const { counter, lastMessage } = props;
  return (
    <>
      {lastMessage === undefined || lastMessage === null ? (
        <div className={`s360-messageNotification-onlyCount ${s360ConfigService?.config?.connectToNextiva && "apply-notification-ctn"}`}>
          <span>{counter}</span>
        </div>
      ) : (
        <div className={`s360-messageNotification-countWithMessage  ${s360ConfigService?.config?.connectToNextiva && "apply-notification-ctn"}`}>
          <span>{counter}</span>
        </div>
      )}
    </>
  );
}
